import Service 			from "./../../Libs/Service";

let ProductFeed = new Service({

	Name: "ProductFeed",

	Libraries: [],

	Events: {

	},

	Actions: {

		// Получение базовой информации о списке товаров
		"ProductFeed": function(productFeed, data) {

			this.setProductFeed(data.ProductFeed, data.ProductFeedCurrencies, data.ProductFeedCategories);

			Broadcast.call("Product Feed Loaded", [data.ProductFeed]);

		},

		"ProductFeedOffersError": function (error) {
			Broadcast.call("Product Feed Offers Error", [{message: error}]);
		},

		// Получение товаров по фильтру
		"ProductFeedOffers": function(productFeedOffers, data) {

			this.setProductFeedOffers(data.ProductFeed, data.ProductFeedOffers);

			Broadcast.call("Product Feed Offers Updated", [data.ProductFeedOffers]);

		}

	},

	init() {

		this.feeds = {};
		this.feedCurrencies = [];
		this.feedCategories = [];
		this.feedOffers = {};

	},

	setProductFeed(productFeed, productFeedCurrencies, productFeedCategories) {

		if (!productFeed) return;

		productFeed.additional_data = JSON.parse(productFeed.additional_data || '{}');

		this.feeds[productFeed.id] = productFeed;
		this.feedCurrencies[productFeed.id] = productFeedCurrencies;
		this.feedCategories[productFeed.id] = productFeedCategories;

	},

	setProductFeedOffers(productFeed, productFeedOffers) {

		if (!this.feedOffers[productFeed.id]) this.feedOffers[productFeed.id] = {};

		_.each(productFeedOffers, productFeedOffer => {

			this.feedOffers[productFeed.id][productFeedOffer["offer_id"]] = productFeedOffer;

		});

	},

	getFeedOfferImage(feedOffer) {

		return JSON.parse(feedOffer.images)[0];

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.ProductFeed) ProductFeed = window.ProductFeed;
else window.ProductFeed = ProductFeed;

export { ProductFeed }

